/* ==========================================================================
   Akel Beauty — money formatting

   Lives in its own asset rather than inline in theme.liquid: the money_format
   placeholder syntax ({{amount}}) and the regex that matches it would both be
   parsed as Liquid output tags inside a .liquid file. Loaded deferred from the
   <head>, so it is ready before any section script runs.
   ========================================================================== */

(function () {
  'use strict';

  window.Akel = window.Akel || {};

  var PLACEHOLDER = /\{\{\s*(\w+)\s*\}\}/;
  var DEFAULT_FORMAT = '${{amount}}';

  function group(cents, precision, thousands, decimal) {
    if (isNaN(cents) || cents === null) return '0';
    var parts = (cents / 100.0).toFixed(precision).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  window.Akel.formatMoney = function (cents, format) {
    var value = typeof cents === 'string' ? cents.replace('.', '') : cents;
    var fmt = format || window.Akel.moneyFormat || DEFAULT_FORMAT;
    var match = fmt.match(PLACEHOLDER);
    var out;

    switch (match && match[1]) {
      case 'amount_no_decimals':
        out = group(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        out = group(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        out = group(value, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        out = group(value, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        out = group(value, 0, ' ', ',');
        break;
      default:
        out = group(value, 2, ',', '.');
    }

    return fmt.replace(PLACEHOLDER, out);
  };
})();
